import React from 'react';

const formatRelativeTime = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays}d ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch (e) { return ''; }
};

const getChatIcon = (title) => {
  const t = (title || '').toLowerCase();
  if (t.includes('lip') || t.includes('gloss') || t.includes('lipstick') || t.includes('tint'))
    return { icon: '💄', bg: '#fde8e8' };
  if (t.includes('foundation') || t.includes('concealer') || t.includes('shade') || t.includes('coverage'))
    return { icon: '🪞', bg: '#f5e6d3' };
  if (t.includes('routine') || t.includes('serum') || t.includes('moisturis') || t.includes('moisturiz') || t.includes('cleanser') || t.includes('sunscreen'))
    return { icon: '🌿', bg: '#e8f0e8' };
  if (t.includes('skin') || t.includes('tone') || t.includes('undertone') || t.includes('analysis') || t.includes('pigment'))
    return { icon: '✨', bg: '#f5e6d3' };
  return { icon: '💬', bg: '#e8eaf5' };
};

const ChatHistoryDrawer = ({
  isOpen,
  onClose,
  chatList = [],
  currentSessionId,
  onNewChat,
  onSwitchChat,
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.45)',
          zIndex: 40,
        }}
      />

      {/* Drawer panel */}
      <div
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          width: 'min(85vw, 300px)',
          background: '#F2EAE1',
          zIndex: 50,
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '4px 0 24px rgba(0,0,0,0.18)',
          animation: 'sonmiDrawerSlideIn 0.22s cubic-bezier(0.4,0,0.2,1)',
        }}
      >
        {/* Drawer header */}
        <div
          style={{
            background: '#341C1C',
            padding: '16px 16px 16px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
          }}
        >
          <span style={{ color: 'white', fontWeight: 600, fontSize: 16, letterSpacing: '0.3px' }}>
            Son:mi
          </span>
          <button
            onClick={onClose}
            aria-label="Close history"
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: 'rgba(255,255,255,0.7)',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Scrollable content */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          {/* New conversation button */}
          <button
            onClick={() => { onNewChat(); onClose(); }}
            style={{
              width: '100%',
              textAlign: 'left',
              background: '#341C1C',
              borderRadius: 16,
              padding: 16,
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              border: 'none',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: 'rgba(255,255,255,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 20,
                flexShrink: 0,
              }}
            >
              ＋
            </div>
            <div>
              <div style={{ color: 'white', fontWeight: 600, fontSize: 14 }}>
                New conversation
              </div>
              <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 13, marginTop: 2 }}>
                Your skin profile carries over
              </div>
            </div>
          </button>

          {/* Recent chats */}
          {chatList.length > 0 && (
            <>
              <div
                style={{
                  color: '#aaa',
                  fontSize: 13,
                  fontWeight: 600,
                  letterSpacing: '0.8px',
                  textTransform: 'uppercase',
                  padding: '4px 4px 0',
                }}
              >
                Recent
              </div>

              {chatList.map((chat) => {
                const { icon, bg } = getChatIcon(chat.title);
                const isActive = chat.sessionId === currentSessionId;
                return (
                  <button
                    key={chat.sessionId}
                    onClick={() => { onSwitchChat(chat.sessionId); onClose(); }}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      background: isActive ? '#F3D5B5' : 'white',
                      borderRadius: 16,
                      padding: 16,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 12,
                      border: 'none',
                      cursor: 'pointer',
                      boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                      transition: 'opacity 0.15s',
                    }}
                  >
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 12,
                        background: bg,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 18,
                        flexShrink: 0,
                      }}
                    >
                      {icon}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: '#1a1a1a',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {chat.title || 'New chat'}
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          color: '#888',
                          marginTop: 3,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {chat.preview || 'No messages yet'}
                      </div>
                    </div>
                    <div style={{ fontSize: 13, color: '#bbb', flexShrink: 0, marginTop: 2 }}>
                      {formatRelativeTime(chat.updatedAt)}
                    </div>
                  </button>
                );
              })}
            </>
          )}

          {/* Empty state */}
          {chatList.length === 0 && (
            <div style={{ textAlign: 'center', padding: '32px 16px' }}>
              <div style={{ fontSize: 32, marginBottom: 12 }}>💬</div>
              <div style={{ fontSize: 14, fontWeight: 500, color: '#888' }}>No past conversations yet</div>
              <div style={{ fontSize: 13, color: '#bbb', marginTop: 4 }}>Start a new conversation above</div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes sonmiDrawerSlideIn {
          from { transform: translateX(-100%); opacity: 0.6; }
          to   { transform: translateX(0);     opacity: 1;   }
        }
      `}</style>
    </>
  );
};

export default ChatHistoryDrawer;
